import React, { useCallback } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useLocalStorage } from 'utils/useLocalStorage';

import {
  FleetFiltersContextProvider,
  defaultFilters as fleetDefaultFilters,
} from 'modules/fleet/filters/context';

import { GateKeepingSection } from 'modules/gatekeeping';
import { JobReviewSection } from 'modules/job-review';
import { DispatchingSection } from 'modules/dispatching';
import { RoutingContextProvider } from 'modules/routing/context';
import { RoutingEventEmitter } from 'modules/routing';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const FleetSectionContent = ({ match }) => {
  const dispatchingSection = useSelector((state) =>
    getSpecificClientConfig(state, constants.DISPATCHING_SECTION)
  );

  const defaultLastSectionVisited = `${match.url}/gatekeeping`;

  const [lastSectionVisited, setLastSectionVisited] = useLocalStorage(
    'fleet/lastSectionVisited',
    defaultLastSectionVisited
  );

  const saveUrlInLocalStorage = useCallback(
    (matchedURL) => {
      const pathname = matchedURL?.location?.pathname;
      setLastSectionVisited(pathname);
    },
    [setLastSectionVisited]
  );

  return (
    <>
      <Route exact path={match.url}>
        <Redirect to={lastSectionVisited} />
      </Route>
      <Route path={match.url} render={saveUrlInLocalStorage} />
      <Route path={`${match.url}/gatekeeping`}>
        <GateKeepingSection parentUrl={match.url} />
      </Route>
      {dispatchingSection && (
        <Route path={`${match.url}/dispatching`}>
          <DispatchingSection parentUrl={match.url} />
        </Route>
      )}
      <Route path={`${match.url}/dispatching-xdock`}>
        <Redirect to={`${match.url}/dispatching`} />
      </Route>
      <Route path={`${match.url}/driver-review`}>
        <JobReviewSection parentUrl={match.url} />
      </Route>
    </>
  );
};

const FleetSection = ({ match }) => {
  return (
    <FleetFiltersContextProvider defaultFilters={fleetDefaultFilters}>
      <RoutingContextProvider eventEmitter={RoutingEventEmitter}>
        <FleetSectionContent match={match} />
      </RoutingContextProvider>
    </FleetFiltersContextProvider>
  );
};

export default FleetSection;
